import {cx} from "@emotion/css";
import {Button as MuiButton} from "@mui/material";
import MuiLoadingButton from "@mui/lab/LoadingButton";
import {useMemo} from "react";

import {noop} from "~/utils/noop";

import {styles} from "./WhiteButton.styles";
import {IButton} from "../IButton";
import {commonStyles} from "../_common/styles";

export interface BmWhiteButtonProps
  extends Pick<IButton, "className" | "sx" | "type" | "disabled" | "active" | "size" | "onClick" | "children"> {
  error?: boolean;
  loading?: boolean;
  loadingIndicator?: string;
}

export const BmWhiteButton: React.FC<BmWhiteButtonProps> = ({
  className,
  size = "large",
  loading,
  loadingIndicator,
  onClick,
  active,
  error,
  ...restProps
}) => {
  const commonProps = useMemo(
    () => ({
      className: cx(commonStyles.button, styles.whiteButton(error), styles.active(active), className),
      size,
      disableFocusRipple: true,
      ...restProps,
    }),
    [active, className, error, restProps, size],
  );

  return loading === undefined ? (
    <MuiButton color="white" variant="contained" onClick={onClick} {...commonProps} />
  ) : (
    <MuiLoadingButton
      color="white"
      variant="contained"
      loading={loading}
      loadingIndicator={loadingIndicator}
      onClick={loading ? noop : onClick}
      {...commonProps}
    />
  );
};
